import * as React from "react";
import { Link } from "react-router-dom";
// components
import { FormattedMessage } from "react-intl";
import NumberFormatter from "@vingle/wtf-sdk/components/numberFormatter";
import PaddedListItem from "common/components/paddedListItem";
import { IconWrapper } from "common/icons";
// styles

import PACKS from "common/icons/packs";
import Icon from "common/icons";
import { VingleURL } from "@vingle/wtf-sdk/url";

const styles = require("./interestItem.scss");

interface IProps {
  interestData: Vingle.UserProfile.IUserInterest;
  isDeleting: boolean;
  username: string;
  children?: any;
  isLast?: boolean;
}

const InterestItem = ({
  interestData,
  children,
  username,
  isDeleting,
}: IProps) => {
  const wrapperStyle = [];
  if (interestData.private) {
    wrapperStyle.push(styles.privateMode);
  }

  if (isDeleting) {
    wrapperStyle.push(styles.cover);
  }

  const boostSummaryElement =
    interestData.received_actions.boost_count > 1 ? (
      <FormattedMessage
        id="interests.boosts_summary"
        values={{
          boost_count: (
            <NumberFormatter
              num={interestData.received_actions.boost_count}
              digits={0}
            />
          ),
        }}
      />
    ) : (
      <FormattedMessage
        id="interests.boost_summary"
        values={{
          boost_count: (
            <NumberFormatter
              num={interestData.received_actions.boost_count}
              digits={0}
            />
          ),
        }}
      />
    );

  const leftElement = (
    <div className={styles.left}>
      <div className={styles.title}>
        <Link
          to={new VingleURL.UserShowInterestDetail({
            username,
            interest: interestData.interest.name,
          }).toString()}
        >
          <IconWrapper
            className={styles.interestMark}
            icon={PACKS.INTEREST_MARK.PROFILE.MY_INTEREST.INTEREST_MARK}
          />
          {interestData.interest.name.split(":")[0]}
        </Link>
        {interestData.private ? (
          <Icon
            className={styles.privateInterest}
            icon="INTERESTS_PRIVATE_MEDIUM"
          />
        ) : null}
      </div>
      <div className={styles.summary}>{boostSummaryElement}</div>
    </div>
  );
  const rightElement = <div className={styles.right}>{children}</div>;

  return (
    <PaddedListItem
      className={wrapperStyle.join(" ")}
      leftElement={leftElement}
      rightElement={rightElement}
    />
  );
};

export default InterestItem;
